import $ from 'jquery';

$(document).on("click", '.study-program__programs-button-first,.study-program__programs-button', function(event) {
    event.preventDefault();
});

$(document).on("mousedown", '.study-program__programs-button-first,.study-program__programs-button', function(event) {
    var decodeUrl = $(this).attr('href');
    const url = new URL(window.location);
    if (url.searchParams.has('rup')) {
        var encodeUrl = url.searchParams.get('rup');
        decodeUrl = atob(encodeUrl);
    }
    switch (event.which) {
        case 1:
            window.location.href = decodeUrl;
            break;
        case 2:
            window.open(decodeUrl);
            break;
        case 3:
            var $this = $(this);
            $this.attr('href', decodeUrl);
            break;
        default:
    }
});